import { createTranslatedText } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { answerToFormValue } from '../../tab/MedicalProfileAnswer.utils';
import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';
import { createFormFieldName } from '../../tab/MedicalProfileTab.utils';

type TextFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly question: DetailQuestionViewModel;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const TextField = (props: TextFieldProps): JSX.Element => {
   return (
      <Textarea
         testId={`detailQuestion-${props.question.questionId}`}
         label={createTranslatedText(props.question.content)}
         controller={props.register(createFormFieldName(props.templateCode, props.question.questionId, props.scope))}
         defaultValue={answerToFormValue(props.question.answerType, props.question.existingAnswer) as string | null}
         maxLength={props.question.config?.maxLength}
         disabled={props.disabled}
         maxRows={6}
         rows={3}
      />
   );
};
